import React from 'react';

interface AIIconProps {
  size?: number;
  color?: string;
  className?: string;
}

const AIIcon: React.FC<AIIconProps> = ({ size = 24, color = 'currentColor', className }) => {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24"><path fill={color} d="M16 3c3.313 0 6 2.695 6 5.994V21H8.001C4.687 21 2 18.305 2 15.006V11h2v4.006A4.005 4.005 0 0 0 8.001 19H20V8.994A4.005 4.005 0 0 0 16 5h-6V3zm-6 10H8v-2h2zm6 0h-2v-2h2zM3.53 1.32a.507.507 0 0 1 .94 0l.254.61a4.37 4.37 0 0 0 2.25 2.327l.718.32a.53.53 0 0 1 0 .962l-.76.338a4.36 4.36 0 0 0-2.218 2.25l-.247.566a.506.506 0 0 1-.934 0l-.247-.565a4.36 4.36 0 0 0-2.219-2.251l-.76-.338a.53.53 0 0 1 0-.963l.718-.32a4.37 4.37 0 0 0 2.251-2.325z"></path></svg>
  );
};

export default AIIcon;
